import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, { type paidToTwcModalQuery } from './__generated__/paidToTwcModalQuery.graphql';

type EntryPointParams = {
	context: paidToTwcModalQuery['variables']['context'];
};

type PaidToTwcModalComponent = EntryPointComponent<
	{ paidToTwcModalQuery: paidToTwcModalQuery },
	Record<string, never>,
	{ onClose: () => void },
	Record<string, never>
>;

export const entryPoint: EntryPoint<PaidToTwcModalComponent, EntryPointParams> = createEntryPoint({
	root: JSResourceForInteraction<PaidToTwcModalComponent>(
		/* webpackChunkName: "@atlaskit-internal_edition-awareness-paid-to-twc-modal" */ './paid-to-twc-modal',
		{
			moduleId: 'edition-awareness-paid-to-twc-modal',
		},
	),
	getPreloadProps: ({ context }: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			paidToTwcModalQuery: {
				parameters,
				variables: { context },
			},
		},
	}),
});
